import { ApolloClient, createNetworkInterface } from 'apollo-client';
import { Constants } from './helpers/constants';

const url = (location.hostname.indexOf('musicinsights.com') >= 0) ? process.env.MI_API_HOST : process.env.API_HOST;
const DIZZEE_LOGIN = (location.hostname.indexOf('musicinsights.com') >= 0) ? process.env.MI_DIZZEE_LOGIN : process.env.DIZZEE_LOGIN;

const networkInterface = createNetworkInterface({
    uri:`${url}/graphql`,
    opts: {
      credentials: 'include',
      mode: 'cors'
    }
});

networkInterface.use([{
   applyMiddleware(req, next) {
     if (!req.options.headers) {
       req.options.headers = {};
     }
     req.options.headers['Application'] = Constants.APPLICATIONNAME;
     next();
   }
 }]);

 networkInterface.useAfter([{
  applyAfterware({ response }, next) {
      if (response.status === 401) {
          window['angularComponentRef'].zone.run(function() { window['angularComponentRef'].componentFn(); });
          location.assign(DIZZEE_LOGIN);
      }
      next();
  }
}]);

const client = new ApolloClient({
  addTypename: false,
  networkInterface
});


export function provideClients() {
  return {
    default: client
  	// extra: extraClient
  };
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/graphql.client.ts